import { apiKey } from "../../../../.frontend.secrets.js";

const CALLBACK_NAME = "googleMapsOnLoad";

const createScriptElmt = function () {
  const scriptElmt = document.createElement("script");
  // eslint-disable-next-line prefer-template
  scriptElmt.src = "https://maps.googleapis.com/maps/api/js" +
                   "?callback=" + CALLBACK_NAME +
                   "&key=" + apiKey;
  document.body.appendChild(scriptElmt);

};

export default function () {

  return new Promise((resolve) => {

    window[CALLBACK_NAME] = function () {
      resolve();
    };

    if (window.google === undefined) {
      createScriptElmt();
    } else {
      resolve();
    }

  });

};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Map/loadGoogleMapsAPI.js